import { type Maybe, emptyUUID, ensure } from '@vrplatform/utils';
import type { connection_bool_exp } from '@vrplatform/graphql';

export function whereConnections({
  search: s,
  teamId,
  status,
  appId,
}: {
  teamId: string;
  search?: Maybe<string>;
  appId?: Maybe<string>;
  status?: Maybe<'archived' | 'active' | 'pending' | 'error'>;
}) {
  const _and: connection_bool_exp[] = [];

  // SEARCH
  const search = s?.trim();
  if (search) {
    _and.push({
      _or: [
        {
          name: { _ilike: `%${search.trim()}%` },
        },
        {
          uniqueRef: { _ilike: `%${search.trim()}%` },
        },
      ],
    });
  }

  if (status === 'pending') {
    _and.push(PENDING);
  }

  if (status === 'error') {
    _and.push(ERROR);
  }

  if (status === 'active') {
    _and.push(
      {
        _not: PENDING,
      },
      {
        _not: ERROR,
      }
    );
  }

  return ensure<connection_bool_exp>({
    tenantId: { _eq: teamId || emptyUUID },
    appId: appId
      ? { _eq: appId, _nin: ['finalytic'] }
      : { _nin: ['finalytic'] },
    status: status !== 'archived' ? { _eq: 'active' } : { _eq: 'inactive' },
    _and: _and.length ? _and : undefined,
  });
}

const PENDING: connection_bool_exp = {
  syncs: {
    status: { _in: ['queued', 'started'] },
    isCurrentOnConnection: { _eq: true },
  },
};

const ERROR: connection_bool_exp = {
  _or: [
    {
      fetchStatus: { _eq: 'failed' },
    },
  ],
};
